import {createInputFieldComponent, IInputFieldBusinessLogic, IInputFieldProperties} from '@vfde-brix/input-field';
import {REQUIRED_VALIDATION_CONFIG} from '../constant';
import {NO_PATTERN_BUSINESS_LOGIC, minLength, maxLength, onlyNumbers} from '@vfde-brix/core';
import {
    INPUT_ZIPCODE_ID,
    INPUT_HOUSE_NUMBER_ID,
    INPUT_CITY_ID,
    INPUT_STREET_ID,
} from '../constant';

/**
 * Input Field BRIX component
 * Zipcode
 *
 */
export const mountInputFieldZipcode = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: onlyNumbers,
                errorKey: 'onlyNumbersZipcode',
            },
            {
                validator: maxLength,
                errorKey: 'maxLengthZipcode',
                maxLength: 5,
            },
            {
                validator: minLength,
                errorKey: 'minLengthZipcode',
                minLength: 5,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_ZIPCODE_ID,
            stdName: INPUT_ZIPCODE_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_ZIPCODE_ID,
            txtText: 'PLZ',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);

};

/**
 * Input Field BRIX component
 * City
 *
 */
export const mountInputFieldCity = (target: HTMLElement, onChange) => {
    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'maxLengthCity',
                maxLength: 30,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_CITY_ID,
            stdName: INPUT_CITY_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_CITY_ID,
            txtText: 'Ort',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * Street
 *
 */
export const mountInputFieldStreet = (target: HTMLElement, onChange) => {

    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'maxLengthStreet',
                maxLength: 50,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_STREET_ID,
            stdName: INPUT_STREET_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_STREET_ID,
            txtText: 'Stra&szlig;e',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};

/**
 * Input Field BRIX component
 * House number
 *
 */
export const mountInputFieldHouseNumber = (target: HTMLElement, onChange) => {

    const inputFieldBusinessLogic: IInputFieldBusinessLogic = {
        onChange,
        validation: [ REQUIRED_VALIDATION_CONFIG,
            {
                validator: maxLength,
                errorKey: 'maxLengthHouseNumber',
                maxLength: 5,
            },
            {
                validator: minLength,
                errorKey: 'minLengthHouseNumber',
                minLength: 1,
            },
        ],
    };

    const inputFieldProperties: IInputFieldProperties = {
        optInputFieldType: 'brix-form-text-input',
        containerInput: {
            stdId: INPUT_HOUSE_NUMBER_ID,
            stdName: INPUT_HOUSE_NUMBER_ID,
            optType: 'text',
            stdValue: '',
            business: NO_PATTERN_BUSINESS_LOGIC,
        },
        containerLabel: {
            stdFor: INPUT_HOUSE_NUMBER_ID,
            txtText: 'Hausnummer',
            business: {},
        },
        business: inputFieldBusinessLogic,
    };

    return createInputFieldComponent(target, inputFieldProperties);
};
